import { Box, Typography } from '@mui/material';
import * as React from 'react';

import muiStyles from './styles';
import { AssetSymbolProps } from './types';

export default function AssetSymbol(props: AssetSymbolProps) {
    const {
        id,
        className,
        attribute,
        styleBox
    } = props;

    const classes = muiStyles(props);

    return (
        <Typography
            className={`${classes.root} ${className}`}
            id={id}
            variant='h4'
        >
            <Box
                className={`${styleBox} ${classes.text}`}
                data-testid='asset-symbol-vale'
            >{attribute}
            </Box>
        </Typography>
    );
}